import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import { toast } from 'react-toastify';

import { Paper, Grid, Typography, FormControlLabel, Radio, Checkbox } from '@material-ui/core';
import Loader from '../../../../../components/Loader';
import Card from '../../../../../components/Card';
import FileUploader from '../../../../../components/FileUploader';
import Input from '../../../../../components/Input';
import Select from '../../../../../components/Select';
import Button from '../../../../../components/Button';
import Modal from '../../../../../components/Modal';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationCircle, faPen } from '@fortawesome/free-solid-svg-icons';

import {
  loadProvisionalReceiptProductConfig,
  loadProvisionalReceiptProductEstablishments,
  attachProvisionalReceiptProduct,
  detachProvisionalReceiptProduct
} from '../../../store/thunk';

import {
  setConfigType,
  setSelectedEstablishmentConfig,
  setCertificateFile
} from '../../../store/actions';

import { formatDocument } from '../../../../../helpers/formatters';

export default function Certificate({ formikProps, onOpenTermsOfUseModal }) {
  const dispatch = useDispatch();

  const { userId } = useSelector(state => state.profile);
  const { establishmentId } = useSelector(state => state.businessInfo);
  const { name, isAdminUser } = useSelector(state => state.profile.submit);

  const { termsOfUseUsers, acceptanceDateTime } = useSelector(state => state.provisionalReceiptConfig);

  const {
    isLoading,
    basicInfo,
    certificate,
    doesConfigExists,
    taxSettingsEstablishments
  } = useSelector(state => state.provisionalReceiptProductConfig);

  const isUserAdmin = +isAdminUser == 1;

  const selectedEstablishmentsWithConfigFromAPI = taxSettingsEstablishments
    ?.find(establishment => establishment?.documentId == basicInfo?.documentId)
    ?.taxSettingsUuid || null;

  const formattedEstablishmentsWithConfig = taxSettingsEstablishments?.map(establishment => {
    return {
      label: `${establishment?.companyName} (${formatDocument(establishment?.documentId)})`,
      value: establishment?.taxSettingsUuid
    }
  });

  const [certificateName, setCertificateName] = useState('');

  const SAME_CNPJ = 'sameCnpj';
  const NEW_CNPJ = 'newCnpj';

  const USE_NEW_CONFIG = 'newConfig';
  const USE_EXISTING_CONFIG = 'existingConfig';

  const isOnlyOneEstablishment = +formattedEstablishmentsWithConfig?.length == 1;
  const isMultipleEstablishment = +formattedEstablishmentsWithConfig?.length > 1;

  const [selectedEstablishmentsWithConfigUuid, setSelectedEstablishmentsWithConfigUuid] = useState(null);
  const [isEditConfigModalOpen, setIsEditConfigModalOpen] = useState(false);
  const [selectedConfig, setSelectedConfig] = useState(isOnlyOneEstablishment ? NEW_CNPJ : SAME_CNPJ);
  const [isNewConfig, setIsNewConfig] = useState(USE_NEW_CONFIG);

  useEffect(() => {
    if(userId) {
      dispatch(loadProvisionalReceiptProductEstablishments(userId, establishmentId, isUserAdmin));
    }
  }, [userId, establishmentId]);

  useEffect(() => {
    setIsNewConfig(USE_NEW_CONFIG);
  }, [establishmentId]);

  const acceptTermsUser = () => {
    const users = termsOfUseUsers?.filter(user => user?.acceptanceDateTime != null && user?.acceptanceDateTime != '' && user?.acceptanceDateTime != '0001-01-01 00:00:00');

    if(users?.length > 0) {
      return {
        name: users[0]?.name,
        termsOfUseDate: users[0]?.acceptanceDateTime
      }
    }

    return {
      name: '',
      termsOfUseDate: ''
    }
  }

  const handleUploadFile = event => {
    const certificate = event.target.files[0];

    if(certificate?.type != 'application/x-pkcs12') {
      return toast.error('A extensão do certificado precisa ser .pfx ou .p12');
    }

    setCertificateName(certificate.name);
    dispatch(setCertificateFile(certificate));
    formikProps.setFieldValue('certificate', certificate);
  }

  return(
    <>
      <Card title="Informações gerais para cadastro da empresa" style={{ marginBottom: 20 }}>
        {isEditConfigModalOpen && (
          <Modal
            title="Atenção"
            open={isEditConfigModalOpen}
            onClose={() => setIsEditConfigModalOpen(false)}
            modalActions={
              <Grid container spacing={2} style={{ display: 'flex', justifyContent: 'flex-end' }}>
                <Grid item>
                  <Button
                    color="error"
                    onClick={() => setIsEditConfigModalOpen(false)}
                  >
                    Cancelar
                  </Button>
                </Grid>
                <Grid item>
                  <Button
                    color="success"
                    onClick={() => {
                      if(selectedConfig == SAME_CNPJ) {
                        dispatch(setSelectedEstablishmentConfig(selectedEstablishmentsWithConfigUuid));
                        dispatch(detachProvisionalReceiptProduct(userId, establishmentId));
                        dispatch(attachProvisionalReceiptProduct(userId, establishmentId, selectedEstablishmentsWithConfigUuid));
                        dispatch(loadProvisionalReceiptProductConfig(userId, establishmentId, true));
                        setIsEditConfigModalOpen(false)
                      }

                      if(selectedConfig == NEW_CNPJ) {
                        dispatch(setConfigType(1));
                        dispatch(detachProvisionalReceiptProduct(userId, establishmentId));
                        dispatch(loadProvisionalReceiptProductConfig(userId, establishmentId, true));
                        setIsEditConfigModalOpen(false)
                      }
                    }}
                  >
                    Prosseguir
                  </Button>
                </Grid>
              </Grid>
            }
          >
            <Grid container spacing={2}>
              <Grid item xs={12}>
                {isMultipleEstablishment && (
                  <FormControlLabel
                    control={
                      <Radio
                        color="primary"
                        checked={selectedConfig == SAME_CNPJ}
                        onChange={() => setSelectedConfig(SAME_CNPJ)}
                      />
                    }
                    label={
                      <Typography color="primary">
                        CNPJ de outro estabelecimento
                      </Typography>
                    }
                  />
                )}
                <FormControlLabel
                  control={
                    <Radio
                      color="primary"
                      checked={selectedConfig == NEW_CNPJ}
                      onChange={() => setSelectedConfig(NEW_CNPJ)}
                    />
                  }
                  label={
                    <Typography color="primary">
                      Novo CNPJ
                    </Typography>
                  }
                />
              </Grid>
              <Grid item xs={12}>
                {(selectedConfig == SAME_CNPJ) && (
                  <>
                    <Typography color="textSecondary">Selecione o estabelecimento:</Typography>
                    <Select
                      value={selectedEstablishmentsWithConfigUuid || selectedEstablishmentsWithConfigFromAPI || basicInfo?.uuid || ""}
                      options={formattedEstablishmentsWithConfig}
                      onChange={event => setSelectedEstablishmentsWithConfigUuid(event.target.value)}
                    />
                  </>
                )}
                {(selectedConfig == NEW_CNPJ) && (
                  <Typography color="textSecondary">
                    Ao selecionar Novo CNPJ, todas as configurações preenchidas anteriormente serão perdidas, deseja prosseguir?
                  </Typography>
                )}
              </Grid>
            </Grid>
          </Modal>
        )}
        {!doesConfigExists && (
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <FormControlLabel
                control={
                  <Radio
                    color="primary"
                    checked={isNewConfig == USE_NEW_CONFIG}
                    onChange={() => setIsNewConfig(USE_NEW_CONFIG)}
                  />
                }
                label={
                  <Typography color="primary">
                    Novo cadastro
                  </Typography>
                }
              />
              <FormControlLabel
                control={
                  <Radio
                    color="primary"
                    checked={isNewConfig == USE_EXISTING_CONFIG}
                    onChange={() => setIsNewConfig(USE_EXISTING_CONFIG)}
                  />
                }
                label={
                  <Typography color="primary">
                    Utilizar configuração já existente
                  </Typography>
                }
              />
            </Grid>
          </Grid>
        )}
        {doesConfigExists && (
          <Grid container>
            <Grid item xs={12}>
              <Typography color='textSecondary' style={{ margin: '10px 0 10px 0' }}>
                <FontAwesomeIcon
                  icon={faExclamationCircle}
                  color="#F5B941"
                  size="lg"
                  style={{ marginRight: 10 }}
                />
                Escolha a opção que mais se enquadra nesta configuração de emissão de nota do novo estabelecimento antes de prosseguir o cadastro.
              </Typography>
            </Grid>
          </Grid>
        )}
        {(doesConfigExists || isNewConfig == USE_EXISTING_CONFIG) && (
          <Grid container>
            <Grid item xs={(isNewConfig == USE_EXISTING_CONFIG) ? 12 : 8} md={(isNewConfig == USE_EXISTING_CONFIG) ? 12 : 10}>
              <Select
                disabled={!(isNewConfig == USE_EXISTING_CONFIG)}
                label={(isNewConfig == USE_EXISTING_CONFIG) ? 'Qual CNPJ?' : ''}
                value={selectedEstablishmentsWithConfigUuid || selectedEstablishmentsWithConfigFromAPI || ''}
                options={formattedEstablishmentsWithConfig}
                onChange={event => {
                  setSelectedEstablishmentsWithConfigUuid(event.target.value);
                  dispatch(setSelectedEstablishmentConfig(event.target.value));
                  dispatch(detachProvisionalReceiptProduct(userId, establishmentId));
                  dispatch(attachProvisionalReceiptProduct(userId, establishmentId, event.target.value));
                  dispatch(loadProvisionalReceiptProductConfig(userId, establishmentId, true));
                }}
              />
            </Grid>
            {!(isNewConfig == USE_EXISTING_CONFIG) && (
              <Grid item xs={4} md={2} style={{ display: 'flex', alignItems: 'center', paddingLeft: 10 }}>
                <Button
                  fullWidth
                  type="button"
                  color="primary"
                  onClick={() => setIsEditConfigModalOpen(true)}
                >
                  <FontAwesomeIcon
                    icon={faPen}
                    color="#FFFFFF"
                    size="lg"
                    style={{ marginRight: 10 }}
                  />
                  Editar
                </Button>
              </Grid>
            )}
          </Grid>
        )}
        <Grid container>
          <Grid item xs={12}>
            <Typography color='textSecondary' style={{ margin: '10px 0 10px 0' }}>
              <FontAwesomeIcon
                icon={faExclamationCircle}
                color="#F5B941"
                size="lg"
                style={{ marginRight: 10 }}
              />
              É necessário escolher o município do CNPJ para configurar corretamente.
            </Typography>
          </Grid>
        </Grid>
        {(!!acceptTermsUser().termsOfUseDate && isUserAdmin) && (
          <Grid container>
            <Grid item xs={12} style={{ display: 'flex', marginTop: 10 }}>
              <Checkbox
                disabled
                checked={true}
                style={{ padding: 0, marginRight: 10 }}
              />
              <Typography
                color='textSecondary'
                variant='subtitle2'
                style={{ cursor: 'pointer', textDecoration: 'underline' }}
                onClick={onOpenTermsOfUseModal}
              >
                Termos de uso aceitos por {acceptTermsUser().name} em {moment(acceptTermsUser().termsOfUseDate).format('LLL')}
              </Typography>
            </Grid>
          </Grid>
        )}
        {(!!acceptanceDateTime && !isUserAdmin) && (
          <Grid container>
            <Grid item xs={12} style={{ display: 'flex', marginTop: 10 }}>
              <Checkbox
                disabled
                checked={true}
                style={{ padding: 0, marginRight: 10 }}
              />
              <Typography
                color='textSecondary'
                variant='subtitle2'
                style={{ cursor: 'pointer', textDecoration: 'underline' }}
                onClick={onOpenTermsOfUseModal}
              >
                Termos de uso aceitos por {name} em {moment(acceptanceDateTime).format('LLL')}
              </Typography>
            </Grid>
          </Grid>
        )}
      </Card>
      <Card title="Certificado Digital A1">
        <Grid item xs={12}>
          <Loader isLoading={isLoading}>
            <Grid item xs={12} style={{ marginBottom: 10, borderBottom: '1px solid #E4E7EA' }}>
              <Typography color="primary">
                <b>Subir certificado digital A1</b>
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography color='textSecondary' style={{ margin: '10px 0 20px 0' }}>
                <FontAwesomeIcon
                  icon={faExclamationCircle}
                  color="#F5B941"
                  size="lg"
                  style={{ marginRight: 10 }}
                />
                É importante que o certificado digital seja do formato A1, qualquer outro formato não será validado.
              </Typography>
            </Grid>
            <Grid container spacing={2}>
              <Grid item>
                <Typography variant="subtitle1" color="textSecondary">
                  {certificateName}
                </Typography>
              </Grid>
            </Grid>
            <Grid container spacing={2}>
              <Grid item>
                <FileUploader
                  name="certificate"
                  file={formikProps.values.certificate}
                  errors={formikProps.errors.certificate}
                  onChange={event => handleUploadFile(event)}
                >
                  Escolher certificado
                </FileUploader>
                {certificate.certificateName && (
                  <Typography variant="subtitle2" style={{ marginTop: 15, color: '#4caf50' }}>
                    {certificate.certificateName && `Nome do Arquivo: ${certificate.certificateName}`}
                    <br />
                    {certificate.certificateExpirationDate && `Expiração: ${moment(certificate.certificateExpirationDate).format('DD/MM/YYYY')}`}
                  </Typography>
                )}
              </Grid>
            </Grid>
            <Grid container spacing={2}>
              <Grid item sm={6} xs={12}>
                <Input
                  name="password"
                  type="password"
                  label="Informe a senha do certificado A1"
                  value={formikProps.values.password || ""}
                  error={formikProps.errors.password}
                  helperText={formikProps.errors.password}
                  onChange={formikProps.handleChange}
                />
              </Grid>
              <Grid item sm={6} xs={12}>
                <Input
                  name="passwordVerify"
                  type="password"
                  label="Repetir senha"
                  value={formikProps.values.passwordVerify || ""}
                  error={formikProps.errors.passwordVerify}
                  helperText={formikProps.errors.passwordVerify}
                  onChange={formikProps.handleChange}
                />
              </Grid>
            </Grid>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Typography color='textSecondary' style={{ margin: '10px 0 20px 0' }}>
                  <FontAwesomeIcon
                    icon={faExclamationCircle}
                    color="#F5B941"
                    size="lg"
                    style={{ marginRight: 10 }}
                  />
                  Ao trocar para o novo certificado, as notas não enviadas por causa do certificado vencido, devem ser reemitidas uma por uma através das listagens de nota.
                </Typography>
              </Grid>
            </Grid>
          </Loader>
        </Grid>
      </Card>
      <Paper style={{ marginTop: 25, marginBottom: 20 }}>
        <Grid container spacing={2} style={{ padding: 20 }}>
          <Grid item xs={12} md={8}>
            <Typography color='primary'>
              <b>Precisa comprar ou renovar o certificado?</b>
            </Typography>
            <Typography color='textSecondary' variant='body2' style={{ margin: '10px 0 10px 0' }}>
              Acesse um atalho para criar ou renovar seu certificado A1 Digital <br />
              Atenção: Estamos apenas indicando, quem vende e renova o certificado é a TecnoSign <br/>
              Selecione a opção Certificado A1 Digital para emitir as notas fiscais
            </Typography>
            <Button
              type='button'
              color='primary'
              onClick={() => window.open('https://certcontrol.com.br:8443/venda-rapida/vd0tp720tkc8df459027', '_blank')}
            >
              Criar/renovar certificado A1 Digital
            </Button>
          </Grid>
          <Grid item xs={12} md={4} style={{ display: 'flex', justifyContent: 'flex-end' }}>
            <svg width="167" height="77" viewBox="0 0 167 77" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M0 6.12479V47.8876C0 49.5205 0.648671 51.0866 1.80331 52.2412C2.95795 53.3958 4.52398 54.0445 6.15689 54.0445H110.997L121.456 67.4048L132.261 54.0445H160.843C162.476 54.0445 164.042 53.3958 165.197 52.2412C166.351 51.0866 167 49.5205 167 47.8876V6.15689C167 4.52398 166.351 2.95795 165.197 1.80331C164.042 0.64867 162.476 5.695e-10 160.843 5.69509e-10H6.15689C4.52953 -2.21181e-05 2.96834 0.64424 1.81462 1.79195C0.660899 2.93965 0.00848468 4.49745 0 6.12479Z" fill="#1A1670"/>
              <path d="M135.361 23.2436C135.249 23.0042 135.065 22.8054 134.835 22.6744C134.605 22.5433 134.341 22.4865 134.077 22.5117C133.685 22.5434 133.321 22.7278 133.063 23.0253C132.19 23.892 131.323 24.7651 130.456 25.6318L127.747 28.3411C127.703 28.3859 127.664 28.4354 127.632 28.4888L127.484 28.3476L127.24 28.1036C126.598 27.4616 126.001 26.8709 125.385 26.2482C125.227 26.0699 125.026 25.9354 124.801 25.8578C124.576 25.7802 124.335 25.7621 124.1 25.8052C123.851 25.8443 123.619 25.9558 123.433 26.126C123.247 26.2961 123.115 26.5172 123.054 26.7618C122.978 27.0074 122.972 27.2697 123.038 27.5184C123.104 27.7671 123.238 27.9922 123.426 28.1678L126.482 31.2173C126.626 31.3886 126.802 31.5296 127 31.6321C127.199 31.7346 127.415 31.7966 127.638 31.8144C127.863 31.7964 128.082 31.7337 128.283 31.6301C128.483 31.5265 128.661 31.384 128.806 31.2109L134.995 25.0219C135.085 24.9256 135.182 24.8293 135.265 24.7202C135.431 24.5141 135.53 24.2615 135.547 23.9971C135.565 23.7328 135.5 23.4696 135.361 23.2436Z" fill="white"/>
              <path d="M153.46 23.7368L142.546 12.585C142.182 12.2132 141.747 11.9178 141.268 11.7161C140.788 11.5143 140.273 11.4103 139.753 11.4102H128.999C128.671 11.4808 128.367 11.6332 128.113 11.8531C125.81 13.8077 123.006 15.0777 120.018 15.519C119.376 15.6153 118.734 15.6924 118.092 15.7694L117.141 15.8786L116.095 16.007L116.043 17.1626V18.7291C116.043 19.737 116.011 20.7835 116.011 21.8107C115.927 24.5609 116.173 27.3111 116.743 30.0028C117.431 33.1967 119.04 36.1188 121.372 38.4067V38.4581L121.475 38.4966L121.751 38.7534C123.786 40.5479 126.152 41.9264 128.717 42.8109C128.878 42.8694 129.047 42.9019 129.218 42.9072H139.663C140.218 42.9067 140.765 42.7879 141.27 42.5587C141.775 42.3296 142.225 41.9953 142.591 41.5783C146.267 37.4009 149.942 33.2171 153.614 29.0269C154.26 28.2883 154.604 27.3327 154.575 26.3516C154.546 25.3706 154.148 24.4365 153.46 23.7368ZM139.978 25.0208C139.93 27.7614 139.297 30.4602 138.122 32.9368C136.903 35.3708 134.982 37.3834 132.607 38.7149C131.811 39.1707 130.957 39.5559 130.039 39.9604L129.237 40.3199C127.093 39.5481 125.114 38.3808 123.401 36.8787C122.884 36.4061 122.403 35.8954 121.963 35.3508C121.822 35.1796 121.687 34.9998 121.558 34.8115C121.514 34.7585 121.473 34.7028 121.436 34.6445C121.321 34.4776 121.205 34.3107 121.096 34.1374L121.045 34.0539C120.925 33.8613 120.809 33.6623 120.698 33.4568L120.602 33.2835C120.499 33.0994 120.403 32.9068 120.313 32.7057L120.274 32.6415L119.992 31.9995L119.915 31.8069C119.831 31.595 119.748 31.3831 119.671 31.1648V31.1071C119.594 30.8759 119.517 30.6384 119.446 30.3944L119.388 30.1954C119.324 29.9579 119.26 29.7139 119.202 29.4699C119.074 28.9242 118.971 28.3721 118.875 27.8007C118.583 25.8374 118.454 23.8532 118.49 21.8685C118.49 20.8541 118.49 19.8205 118.522 18.819V18.2925C119.164 18.2219 119.806 18.1449 120.448 18.0486L120.762 17.9972L121.083 17.9458L121.417 17.8752L121.745 17.8046L122.059 17.734L122.406 17.6505L122.688 17.5735L123.074 17.4579L123.317 17.3873L123.767 17.2396L123.934 17.1818C124.364 17.0278 124.788 16.8608 125.218 16.6811C125.41 16.5976 125.609 16.5077 125.802 16.4114C127.049 15.8075 128.227 15.0691 129.314 14.2093C131.988 16.3298 135.188 17.6835 138.572 18.1256C139.072 18.1962 139.58 18.254 140.08 18.3054V19.8141C140.048 21.5026 140.061 23.3066 139.984 25.0336L139.978 25.0208ZM13.54 21.4255L14.779 21.1045L15.222 18.774C15.2756 18.4964 15.424 18.2459 15.6418 18.0656C15.8596 17.8852 16.1334 17.7862 16.4162 17.7853H17.1224C17.301 17.7858 17.4773 17.8258 17.6388 17.9023C17.8002 17.9789 17.9427 18.0901 18.0562 18.2281C18.1696 18.3661 18.2512 18.5274 18.2951 18.7006C18.339 18.8738 18.3441 19.0545 18.3101 19.2299L17.957 21.1045H19.2988C19.4781 21.1049 19.6551 21.1449 19.8171 21.2218C19.979 21.2987 20.122 21.4106 20.2355 21.5493C20.3491 21.6881 20.4305 21.8503 20.4739 22.0242C20.5173 22.1982 20.5216 22.3796 20.4865 22.5555C20.4328 22.8308 20.2848 23.0788 20.0681 23.2569C19.8513 23.435 19.5793 23.532 19.2988 23.5313H17.4691L16.5895 28.2951C16.2621 29.9065 16.5381 30.5357 17.758 30.5357H17.8735C18.0545 30.5326 18.2339 30.5698 18.3987 30.6446C18.5635 30.7194 18.7096 30.83 18.8264 30.9683C18.9432 31.1066 19.0277 31.2692 19.0739 31.4442C19.1201 31.6192 19.1267 31.8023 19.0934 31.9802L19.0484 32.2049C19.0027 32.4532 18.8802 32.6809 18.6982 32.856C18.5162 33.0311 18.2839 33.1446 18.034 33.1808C17.5538 33.2543 17.0689 33.2929 16.5831 33.2963C13.8738 33.2963 12.6347 32.0123 13.1034 29.5598L14.2718 23.5378H12.4229L12.6476 22.3757C12.6897 22.1485 12.7963 21.9382 12.9545 21.7698C13.1126 21.6014 13.3159 21.4819 13.54 21.4255ZM20.8075 27.0817C21.6421 22.716 23.8186 20.8477 27.7412 20.8477C31.2402 20.8477 32.6655 22.7352 31.9143 26.5167L31.8309 26.9918C31.7748 27.2897 31.6152 27.5582 31.3802 27.7497C31.1452 27.9413 30.85 28.0435 30.5468 28.0383H24.0047C23.9084 29.7909 24.7751 30.5357 26.3866 30.5357C27.0222 30.5376 27.6544 30.4424 28.2613 30.2532C28.4561 30.1984 28.661 30.1905 28.8595 30.2299C29.0579 30.2694 29.2442 30.3553 29.4032 30.4804C29.5622 30.6056 29.6893 30.7666 29.7743 30.9502C29.8592 31.1339 29.8995 31.335 29.892 31.5372C29.885 31.7704 29.8127 31.9969 29.6834 32.191C29.554 32.3851 29.3727 32.539 29.1601 32.635C28.1236 33.0837 27.0022 33.3028 25.873 33.2771C21.7256 33.2899 19.9408 31.4666 20.8075 27.0817ZM24.3322 26.1251H28.8262C29.1537 24.443 28.6144 23.602 27.1185 23.602C25.6226 23.602 24.7944 24.3724 24.3322 26.1251ZM32.8966 27.0817C33.7376 22.716 35.959 20.8477 39.9972 20.8477C40.8813 20.8348 41.7576 21.0144 42.5653 21.3742C42.8411 21.5057 43.059 21.7341 43.1773 22.0159C43.2957 22.2976 43.3064 22.6131 43.2073 22.9022L43.0789 23.2745C43.0231 23.44 42.933 23.5918 42.8144 23.72C42.6958 23.8483 42.5514 23.9499 42.3908 24.0184C42.2301 24.0869 42.0568 24.1207 41.8822 24.1175C41.7076 24.1144 41.5356 24.0743 41.3776 24C40.7753 23.7192 40.1158 23.5829 39.4515 23.602C37.6282 23.602 36.6524 24.6292 36.1837 27.0817C35.715 29.5341 36.2736 30.5357 38.1097 30.5357C38.7367 30.5416 39.36 30.4395 39.9523 30.2339C40.1434 30.1693 40.3473 30.1521 40.5465 30.1837C40.7458 30.2154 40.9343 30.2949 41.096 30.4156C41.2577 30.5362 41.3877 30.6943 41.4747 30.8762C41.5618 31.0582 41.6034 31.2586 41.5958 31.4602C41.5869 31.6766 41.5233 31.8872 41.411 32.0724C41.2988 32.2576 41.1415 32.4114 40.9538 32.5195C39.9079 33.0416 38.7522 33.3057 37.5833 33.2899C33.5065 33.2899 32.0363 31.4473 32.8966 27.0817ZM46.9759 21.1045H47.1364C47.5187 21.1043 47.886 21.2531 48.1604 21.5191C48.4349 21.7852 48.5949 22.1477 48.6066 22.5298C48.9971 21.9891 49.5147 21.5528 50.1138 21.2595C50.7128 20.9661 51.3748 20.8247 52.0414 20.8477C55.0267 20.8477 56.0347 22.2024 55.4248 25.3418L54.1408 31.8325C54.0752 32.1691 53.8945 32.4723 53.6297 32.6902C53.365 32.9081 53.0327 33.027 52.6898 33.0267H52.5421C52.325 33.0269 52.1105 32.9791 51.914 32.8865C51.7175 32.794 51.544 32.6591 51.4059 32.4915C51.2678 32.3239 51.1685 32.1279 51.1152 31.9173C51.0619 31.7068 51.0559 31.4871 51.0976 31.274L52.112 26.0416C52.4394 24.3403 51.9258 23.7111 50.7574 23.7111C49.4027 23.7111 48.4718 24.6869 47.8619 26.5359L46.8347 31.8325C46.7693 32.168 46.5896 32.4704 46.3261 32.6882C46.0627 32.9059 45.7319 33.0256 45.3901 33.0267H43.4256L45.5314 22.2601C45.6034 21.9312 45.7862 21.637 46.0491 21.4267C46.312 21.2163 46.6392 21.1026 46.9759 21.1045ZM56.9463 27.0817C57.7874 22.716 59.9317 20.8477 63.8544 20.8477C67.7771 20.8477 69.2023 22.7352 68.3485 27.0817C67.4946 31.4281 65.3374 33.2899 61.4147 33.2899C57.4921 33.2899 56.0796 31.4666 56.9463 27.0817ZM61.9861 30.5357C63.6682 30.5357 64.5991 29.5085 65.0678 27.0817C65.5365 24.6548 65.0228 23.602 63.3408 23.602C61.6587 23.602 60.7021 24.6292 60.2334 27.0817C59.7648 29.5341 60.2848 30.5357 61.9861 30.5357ZM69.029 31.0108C69.1518 30.6804 69.4003 30.412 69.7202 30.2641C70.0401 30.1162 70.4055 30.1007 70.7367 30.2211C71.5309 30.5142 72.3685 30.6726 73.2149 30.6898C74.4283 30.6898 75.1409 30.2211 75.2501 29.547C75.6417 27.5118 69.2922 29.2645 70.2039 24.5008C70.6918 21.9777 72.6114 20.8606 75.6674 20.8606C76.5351 20.8599 77.399 20.9765 78.2354 21.2073C78.4161 21.2575 78.5843 21.3449 78.7293 21.4638C78.8743 21.5828 78.9928 21.7306 79.0774 21.898C79.162 22.0654 79.2108 22.2486 79.2206 22.4358C79.2303 22.6231 79.2009 22.8104 79.1343 22.9856C79.0087 23.3124 78.7609 23.5774 78.4434 23.7248C78.1259 23.8722 77.7635 23.8903 77.4329 23.7753C76.7705 23.5544 76.0768 23.4417 75.3785 23.4414C74.2999 23.4414 73.6515 23.7432 73.5295 24.443C73.1122 26.5488 79.5066 24.6805 78.55 29.5791C78.0621 32.1022 76.1489 33.2706 73.0159 33.2706C71.9562 33.274 70.9013 33.127 69.8829 32.8341C69.7055 32.7816 69.5409 32.6931 69.3994 32.574C69.2578 32.455 69.1425 32.3079 69.0605 32.1421C68.9785 31.9763 68.9316 31.7954 68.9229 31.6106C68.9142 31.4259 68.9437 31.2413 69.0097 31.0685L69.029 31.0108ZM83.4422 21.1045C83.6717 21.1051 83.8984 21.1563 84.1058 21.2546C84.3133 21.3528 84.4966 21.4956 84.6425 21.6728C84.7885 21.8501 84.8935 22.0573 84.9501 22.2798C85.0068 22.5023 85.0136 22.7345 84.9701 22.9599L83.2431 31.794C83.1786 32.1529 82.9905 32.4778 82.7113 32.7123C82.4322 32.9469 82.0797 33.0763 81.7151 33.078H79.8212L81.9142 22.3821C81.9788 22.0239 82.1673 21.6998 82.4465 21.4663C82.7258 21.2328 83.0781 21.1048 83.4422 21.1045ZM84.2382 16.2445H84.5592C84.7727 16.2453 84.9834 16.2932 85.1762 16.3848C85.369 16.4764 85.5393 16.6094 85.6748 16.7744C85.8103 16.9393 85.9077 17.1321 85.9602 17.3391C86.0126 17.546 86.0187 17.7619 85.9781 17.9715C85.9152 18.3013 85.7388 18.5986 85.4797 18.812C85.2206 19.0254 84.8949 19.1414 84.5592 19.14H82.4856L82.8194 17.4194C82.8822 17.089 83.0582 16.7909 83.3172 16.5764C83.5762 16.362 83.902 16.2446 84.2382 16.2445ZM85.4131 35.8066C85.4767 35.6185 85.5778 35.4452 85.7104 35.2974C85.8431 35.1496 86.0044 35.0304 86.1846 34.9469C86.3647 34.8634 86.56 34.8175 86.7585 34.8118C86.957 34.8062 87.1545 34.841 87.3392 34.9142C88.0906 35.2095 88.8882 35.3703 89.6953 35.3893C91.8397 35.3893 92.9054 34.3877 93.4319 31.7748L93.4768 31.4473C93.0094 31.9246 92.4494 32.3012 91.8311 32.554C91.2128 32.8068 90.5494 32.9306 89.8815 32.9175C86.4468 32.9175 85.2334 31.1199 86.0295 26.8955C86.8256 22.671 88.7837 20.8477 92.212 20.8477C93.7336 20.8477 94.7095 21.3806 95.2744 22.3885L95.4285 22.0033C95.5409 21.7369 95.7293 21.5095 95.9703 21.3497C96.2112 21.1898 96.494 21.1045 96.7832 21.1045H96.873C97.0894 21.1043 97.3031 21.1519 97.4988 21.2441C97.6945 21.3363 97.8673 21.4708 98.0048 21.6378C98.1423 21.8048 98.2411 22.0002 98.2941 22.2099C98.3471 22.4197 98.3529 22.6385 98.3111 22.8508L96.5071 32.0765C95.6917 36.3459 93.5667 38.1435 89.3679 38.1435C88.3203 38.1664 87.277 38.0033 86.2863 37.662C85.9267 37.5287 85.6338 37.2597 85.4705 36.9127C85.3072 36.5658 85.2866 36.1686 85.4131 35.8066ZM91.1912 30.1633C91.8239 30.1617 92.4414 29.969 92.9626 29.6104C93.4839 29.2518 93.8847 28.7441 94.1124 28.1538L94.5746 25.7013C94.5297 24.3017 93.8042 23.602 92.4753 23.602C90.7033 23.602 89.7916 24.5842 89.323 26.8955C88.8543 29.2067 89.4193 30.1633 91.1912 30.1633ZM102.491 21.1045H102.658C103.039 21.106 103.406 21.2552 103.68 21.5209C103.954 21.7867 104.114 22.1482 104.128 22.5298C104.516 21.9888 105.033 21.5521 105.631 21.2587C106.229 20.9652 106.89 20.8241 107.556 20.8477C110.548 20.8477 111.549 22.2024 110.946 25.3418L109.662 31.8325C109.598 32.1686 109.418 32.4717 109.155 32.6896C108.891 32.9076 108.559 33.0268 108.217 33.0267H108.038C107.821 33.0258 107.607 32.9772 107.411 32.8843C107.215 32.7914 107.042 32.6565 106.904 32.4892C106.766 32.3219 106.667 32.1263 106.613 31.9163C106.559 31.7062 106.553 31.487 106.593 31.274L107.607 26.0416C107.935 24.3403 107.421 23.7111 106.253 23.7111C104.898 23.7111 103.967 24.6869 103.357 26.5359L102.33 31.8325C102.266 32.1686 102.086 32.4717 101.823 32.6896C101.559 32.9076 101.228 33.0268 100.886 33.0267H98.9211L101.027 22.2601C101.1 21.928 101.285 21.6312 101.552 21.4205C101.819 21.2098 102.151 21.0981 102.491 21.1045Z" fill="white"/>
              <rect x="77" y="54" width="77" height="23" fill="#FCFCFC"/>
            </svg>
          </Grid>
        </Grid>
      </Paper>
    </>
  );
}